import React from "react";
import {
  Card,
  Input,
  Headline,
  InputLabel,
  Flex,
  Paragraph,
} from "_styleguide";
import Footer from "../_components/Footer/Footer";
import { useLead } from "_contexts/useLead";
import { validatePersonalForm } from "./_helpers";
import "./Personal.scss";

function Personal(props) {
  const { lead, updateLead } = useLead();
  const settings = props.settings?.settings;

  const validation = validatePersonalForm(lead);

  return (
    <Card id="personal">
      <div className="apply-form">
        <Headline>{settings.title}</Headline>
        {settings?.subtitle ? (
          <Paragraph
            opacity={0.6}
            align="left"
            size="14px"
            dangerouslySetInnerHTML={{
              __html: settings?.subtitle,
            }}
          />
        ) : null}
        <div
          className="apply-form-items"
          style={{ marginTop: settings?.subtitle ? "0" : "24px" }}
        >
          <Flex align="center" gap={12}>
            <Flex vertical style={{ flex: 1 }}>
              <InputLabel htmlFor="first_name" {...validation.first_name}>
                First Name:
              </InputLabel>
              <Input
                id="first_name"
                value={lead.first_name}
                onChange={(e) => updateLead("first_name", e.target.value)}
                size="medium"
                placeholder="e.g. Franklin"
                autoFocus
                {...validation.first_name}
              />
            </Flex>
            <Flex vertical style={{ maxWidth: "60px" }}>
              <InputLabel htmlFor="middle_name">M.I.:</InputLabel>
              <Input
                id="middle_name"
                value={lead.middle_name}
                onChange={(e) =>
                  updateLead("middle_name", e.target.value?.toUpperCase())
                }
                size="medium"
                maxLength={1}
                placeholder=""
              />
            </Flex>
          </Flex>
          <Flex vertical>
            <InputLabel htmlFor="last_name" {...validation.last_name}>
              Last Name:
            </InputLabel>
            <Input
              id="last_name"
              value={lead.last_name}
              onChange={(e) => updateLead("last_name", e.target.value)}
              size="medium"
              placeholder="e.g. Richardson"
              {...validation.last_name}
            />
          </Flex>
        </div>
      </div>
      <Footer
        next={props.settings.next}
        settings={props.settings}
        disableNext={!validation.allValid}
      />
    </Card>
  );
}

export default Personal;
